import { useState } from "react";
import { MessageSquareText, Plus, Menu } from "lucide-react";
import NewTitleDialog from "@/components/NewTitleDialog";

const COLORS = ["#2563EB", "#8B5CF6", "#EC4899", "#F59E0B", "#10B981", "#EF4444", "#06B6D4"];

export default function EmptyState({ onCreate, onOpenSidebar }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="flex-1 flex flex-col">
      {/* Mobile mini-header so users can reach the sidebar even when no note is open */}
      <header className="md:hidden h-14 flex items-center gap-3 px-4 border-b border-[#1E1E1E]">
        <button
          data-testid="open-sidebar-btn"
          onClick={onOpenSidebar}
          aria-label="Open menu"
          className="h-10 w-10 rounded-full bg-[#1E1E1E] hover:bg-[#27272A] border border-[#27272A] text-[#9CA3AF] hover:text-[#F3F4F6] flex items-center justify-center transition-all"
        >
          <Menu className="h-4 w-4" />
        </button>
        <span className="font-heading text-base font-semibold">NoteLosh</span>
      </header>

      <div className="flex-1 flex items-center justify-center px-6">
        <div className="text-center space-y-5 max-w-md">
          <div className="h-16 w-16 rounded-2xl bg-[#1E1E1E] border border-[#27272A] flex items-center justify-center mx-auto">
            <MessageSquareText className="h-7 w-7 text-[#3B82F6]" />
          </div>
          <div>
            <h2 className="font-heading text-2xl font-semibold">Start your first thread</h2>
            <p className="text-sm text-[#9CA3AF] mt-1.5">
              Create a title to group related links and notes. Think of it like a chat thread for a topic.
            </p>
          </div>
          <button
            data-testid="empty-create-title-btn"
            onClick={() => setOpen(true)}
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#2563EB] hover:bg-[#1D4ED8] text-white text-sm font-medium transition-all glow-blue"
          >
            <Plus className="h-4 w-4" /> Create a title
          </button>
        </div>
        <NewTitleDialog open={open} onOpenChange={setOpen} onCreate={onCreate} colors={COLORS} />
      </div>
    </div>
  );
}
